import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-magnific-large.tsx
/**
* icon.24.logo.magnific.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjIwMSA1Ljc3NyAxMiAxMC4wNjhsMS44LTQuMjloMy42TDIxIDE4LjIyMWgtNC41TDEyIDEyLjY0NGwtNC41IDUuNTc4SDNMNi42IDUuNzc3eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11939
*/
const Icon24LogoMagnificLarge = memo(function Icon24LogoMagnificLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10.201 5.777 12 10.068l1.8-4.29h3.6L21 18.221h-4.5L12 12.644l-4.5 5.578H3L6.6 5.777z"
		})
	});
});
//#endregion
export { Icon24LogoMagnificLarge };

//# sourceMappingURL=icon-24-logo-magnific-large.js.map